(function () {
  function getStickyHeaderOffset() {
    const header = document.querySelector(
      '.shopify-section-header-sticky, sticky-header, #shopify-section-header, .header-wrapper'
    );

    if (!header) return 0;

    const styles = window.getComputedStyle(header);

    if (styles.position !== 'fixed' && styles.position !== 'sticky') return 0;

    return header.getBoundingClientRect().height || 0;
  }

  function scrollProductMediaIntoView(hero) {
    if (!hero) return;

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const target = desktopQuery.matches
      ? hero.querySelector('[data-moducube-color-carousel]')
      : hero.querySelector('[data-moducube-gallery-track]') || hero.querySelector('[data-moducube-gallery]');

    if (!target) return;

    const headerOffset = getStickyHeaderOffset();
    const clearance = desktopQuery.matches ? 40 : 16;
    const targetTop = window.scrollY + target.getBoundingClientRect().top - headerOffset - clearance;

    window.scrollTo({
      top: Math.max(0, targetTop),
      behavior: 'smooth',
    });
  }

  function initGallery(gallery) {
    if (gallery.dataset.moducubeGalleryInitialized === 'true') return;

    const track = gallery.querySelector('[data-moducube-gallery-track]');
    const slides = Array.from(gallery.querySelectorAll('[data-moducube-gallery-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-moducube-gallery-thumb]'));
    const hero = gallery.closest('.moducube-product-hero');
    const coverSwatches = hero ? Array.from(hero.querySelectorAll('[data-moducube-cover-swatch]')) : [];
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    if (!track || slides.length === 0 || thumbs.length === 0) return;

    gallery.dataset.moducubeGalleryInitialized = 'true';
    initMobileVideoPopup(gallery);
    initDesktopFeatureCards(track);

    function setActive(index) {
      thumbs.forEach((thumb) => {
        const thumbIndex = Number(thumb.dataset.moducubeGalleryIndex || 0);
        const isActive = thumbIndex === index;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-pressed', String(isActive));
      });

      coverSwatches.forEach((swatch) => {
        const swatchIndex = Number(swatch.dataset.moducubeColorIndex || 0);
        const isActive = index < 3 && swatchIndex === index;
        swatch.classList.toggle('is-active', isActive);
        swatch.setAttribute('aria-pressed', String(isActive));
      });
    }

    function goToIndex(index) {
      const slide = slides[index];
      if (!slide) return;

      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      setActive(index);
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.moducubeGalleryIndex || 0);
        goToIndex(index);
      });
    });

    coverSwatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        if (!mobileQuery.matches) return;

        scrollProductMediaIntoView(hero);
        goToIndex(Number(swatch.dataset.moducubeColorIndex || 0));
      });
    });

    let scrollTimer;
    track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(scrollTimer);
        scrollTimer = window.setTimeout(() => {
          const trackLeft = track.getBoundingClientRect().left;
          let activeIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;

          slides.forEach((slide, index) => {
            const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              activeIndex = index;
            }
          });

          setActive(Math.min(activeIndex, thumbs.length - 1));
        }, 80);
      },
      { passive: true }
    );
  }

  function initDesktopColorCarousel(carousel) {
    if (!carousel || carousel.dataset.moducubeColorCarouselInitialized === 'true') return;

    const track = carousel.querySelector('[data-moducube-color-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-moducube-color-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-moducube-color-dot]'));
    const hero = carousel.closest('.moducube-product-hero');
    const coverSwatches = hero ? Array.from(hero.querySelectorAll('[data-moducube-cover-swatch]')) : [];

    if (!track || slides.length === 0 || dots.length === 0) return;

    carousel.dataset.moducubeColorCarouselInitialized = 'true';

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const autoplaySequence = [1, 2, 0];
    let activeIndex = 0;
    let autoplayTimer;
    let autoplayStep = 0;
    let scrollTimer;
    let isHoverPaused = false;
    let isFocusPaused = false;
    let isDragging = false;
    let dragPointerId;
    let dragStartX = 0;
    let dragStartScroll = 0;

    function normalizeIndex(index) {
      return (index + slides.length) % slides.length;
    }

    function setActive(index) {
      activeIndex = normalizeIndex(index);

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-pressed', String(isActive));
      });

      coverSwatches.forEach((swatch) => {
        const swatchIndex = Number(swatch.dataset.moducubeColorIndex || 0);
        const isActive = swatchIndex === activeIndex;
        swatch.classList.toggle('is-active', isActive);
        swatch.setAttribute('aria-pressed', String(isActive));
      });
    }

    function goTo(index) {
      const nextIndex = normalizeIndex(index);
      const slide = slides[nextIndex];

      if (!slide) return;

      setActive(nextIndex);
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth',
      });
    }

    function getNearestIndex() {
      const trackLeft = track.getBoundingClientRect().left;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;

      slides.forEach((slide, index) => {
        const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function stopAutoplay() {
      window.clearTimeout(autoplayTimer);
      autoplayTimer = undefined;
    }

    function completeAutoplay() {
      autoplayStep = autoplaySequence.length;
      stopAutoplay();
    }

    function shouldAutoplay() {
      return (
        desktopQuery.matches &&
        !reduceMotionQuery.matches &&
        !document.hidden &&
        !isHoverPaused &&
        !isFocusPaused &&
        !isDragging &&
        autoplayStep < autoplaySequence.length
      );
    }

    function startAutoplay() {
      stopAutoplay();

      if (!shouldAutoplay()) return;

      autoplayTimer = window.setTimeout(() => {
        const nextIndex = autoplaySequence[autoplayStep];
        autoplayStep += 1;
        goTo(nextIndex);
        startAutoplay();
      }, 5000);
    }

    function syncFromScroll() {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        setActive(getNearestIndex());
      }, 80);
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        completeAutoplay();
        goTo(Number(dot.dataset.moducubeColorIndex || 0));
      });
    });

    coverSwatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        if (!desktopQuery.matches) return;

        completeAutoplay();
        scrollProductMediaIntoView(hero);
        goTo(Number(swatch.dataset.moducubeColorIndex || 0));
      });
    });

    track.addEventListener(
      'scroll',
      () => {
        syncFromScroll();
      },
      { passive: true }
    );

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') return;

      isDragging = true;
      dragPointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(dragPointerId);
      completeAutoplay();
    });

    track.addEventListener('pointermove', (event) => {
      if (!isDragging || event.pointerId !== dragPointerId) return;

      event.preventDefault();
      track.scrollLeft = dragStartScroll - (event.clientX - dragStartX);
    });

    function endDrag(event) {
      if (!isDragging || event.pointerId !== dragPointerId) return;

      isDragging = false;
      track.classList.remove('is-dragging');
      setActive(getNearestIndex());

      if (track.hasPointerCapture(dragPointerId)) {
        track.releasePointerCapture(dragPointerId);
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    carousel.addEventListener('mouseenter', () => {
      isHoverPaused = true;
      stopAutoplay();
    });
    carousel.addEventListener('mouseleave', () => {
      isHoverPaused = false;
      startAutoplay();
    });
    carousel.addEventListener('focusin', () => {
      isFocusPaused = true;
      stopAutoplay();
    });
    carousel.addEventListener('focusout', () => {
      isFocusPaused = false;
      startAutoplay();
    });
    document.addEventListener('visibilitychange', startAutoplay);

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', startAutoplay);
      reduceMotionQuery.addEventListener('change', startAutoplay);
    }

    setActive(0);
    startAutoplay();
  }

  function initMobileVideoPopup(gallery) {
    const hero = gallery.closest('.moducube-product-hero');
    const trigger = gallery.querySelector('[data-moducube-mobile-video-trigger]');
    const popup = hero ? hero.querySelector('[data-moducube-mobile-video-popup]') : null;
    const video = popup ? popup.querySelector('[data-moducube-mobile-video-popup-media]') : null;
    const closeButtons = popup ? Array.from(popup.querySelectorAll('[data-moducube-mobile-video-popup-close]')) : [];
    const mobileQuery = window.matchMedia('(max-width: 989px)');
    let returnFocus = null;

    if (!trigger || !popup || !video || closeButtons.length === 0) return;
    if (popup.dataset.moducubeMobileVideoPopupInitialized === 'true') return;

    popup.dataset.moducubeMobileVideoPopupInitialized = 'true';

    function openPopup(event) {
      if (!mobileQuery.matches) return;

      returnFocus = event.target.closest('button') || trigger;
      popup.hidden = false;
      popup.setAttribute('aria-hidden', 'false');
      document.body.classList.add('moducube-video-popup-open');

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }

      closeButtons.find((button) => button.tabIndex !== -1)?.focus({ preventScroll: true });
    }

    function closePopup(restoreFocus = true) {
      if (popup.hidden) return;

      video.pause();
      video.currentTime = 0;
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('moducube-video-popup-open');

      if (restoreFocus && returnFocus) {
        returnFocus.focus({ preventScroll: true });
      }
    }

    function setVideoLabel() {
      video.setAttribute('aria-label', video.paused ? 'Play product video' : 'Pause product video');
    }

    function toggleVideo() {
      if (video.paused || video.ended) {
        const playPromise = video.play();

        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      } else {
        video.pause();
      }
    }

    trigger.addEventListener('click', openPopup);
    closeButtons.forEach((button) => {
      button.addEventListener('click', () => closePopup());
    });
    video.addEventListener('click', toggleVideo);
    video.addEventListener('play', setVideoLabel);
    video.addEventListener('pause', setVideoLabel);
    video.addEventListener('ended', setVideoLabel);
    video.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      toggleVideo();
    });

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = [closeButtons.find((button) => button.tabIndex !== -1), video].filter(Boolean);
      const currentIndex = focusable.indexOf(document.activeElement);
      const nextIndex = event.shiftKey
        ? (currentIndex - 1 + focusable.length) % focusable.length
        : (currentIndex + 1) % focusable.length;

      event.preventDefault();
      focusable[nextIndex].focus();
    });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', (event) => {
        if (!event.matches) closePopup(false);
      });
    }
  }

  function initDesktopVideo(container) {
    if (!container || container.dataset.moducubeDesktopVideoInitialized === 'true') return;

    const video = container.querySelector('[data-moducube-desktop-video-media]');
    const toggle = container.querySelector('[data-moducube-desktop-video-toggle]');

    if (!video || !toggle) return;

    container.dataset.moducubeDesktopVideoInitialized = 'true';

    function setPlaying(isPlaying) {
      container.classList.toggle('is-playing', isPlaying);
      toggle.setAttribute('aria-label', isPlaying ? 'Pause product video' : 'Play product video');
    }

    function playVideo() {
      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {
          setPlaying(false);
        });
      }
    }

    function toggleVideo() {
      if (video.paused || video.ended) {
        playVideo();
      } else {
        video.pause();
      }
    }

    toggle.addEventListener('click', (event) => {
      event.stopPropagation();
      toggleVideo();
    });

    video.addEventListener('click', toggleVideo);
    video.addEventListener('play', () => setPlaying(true));
    video.addEventListener('pause', () => setPlaying(false));
    video.addEventListener('ended', () => setPlaying(false));
  }

  function initDesktopFeatureCards(grid) {
    if (!grid || grid.dataset.moducubeFeatureGridInitialized === 'true') return;

    const cards = Array.from(grid.querySelectorAll('[data-moducube-feature-card]'));

    if (cards.length === 0) return;

    grid.dataset.moducubeFeatureGridInitialized = 'true';

    function setExpanded(card, isExpanded) {
      card.classList.toggle('is-expanded', isExpanded);
      card.setAttribute('aria-expanded', String(isExpanded));
    }

    function closeOtherCards(activeCard) {
      cards.forEach((card) => {
        if (card === activeCard) return;
        setExpanded(card, false);
      });
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        const shouldExpand = card.getAttribute('aria-expanded') !== 'true';

        closeOtherCards(card);
        setExpanded(card, shouldExpand);
      });
    });

    grid.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      cards.forEach((card) => setExpanded(card, false));
    });
  }

  function initDesktopGallery(gallery) {
    if (gallery.dataset.moducubeDesktopGalleryInitialized === 'true') return;

    gallery.dataset.moducubeDesktopGalleryInitialized = 'true';
    initDesktopColorCarousel(gallery.querySelector('[data-moducube-color-carousel]'));
    initDesktopVideo(gallery.querySelector('[data-moducube-desktop-video]'));
    initDesktopFeatureCards(gallery.querySelector('[data-moducube-feature-grid]'));
  }

  function initFitGuide(guide) {
    if (guide.dataset.moducubeFitInitialized === 'true') return;

    const swiperElement = guide.querySelector('[data-moducube-fit-swiper]');
    const tabs = Array.from(guide.querySelectorAll('[data-moducube-fit-tab]'));

    if (!swiperElement || tabs.length === 0) return;

    if (!window.Swiper) {
      const retryCount = Number(guide.dataset.moducubeFitRetryCount || 0);

      if (retryCount < 50) {
        guide.dataset.moducubeFitRetryCount = String(retryCount + 1);
        window.setTimeout(() => initFitGuide(guide), 100);
      }

      return;
    }

    guide.dataset.moducubeFitInitialized = 'true';

    const initialSlide = Number(swiperElement.dataset.moducubeFitInitialSlide || 0);

    function setActive(index) {
      tabs.forEach((tab, tabIndex) => {
        const isActive = tabIndex === index;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));
        tab.setAttribute('tabindex', isActive ? '0' : '-1');
      });
    }

    const swiper = new window.Swiper(swiperElement, {
      initialSlide,
      slidesPerView: 1,
      speed: 350,
      threshold: 8,
      allowTouchMove: true,
      autoHeight: false,
      on: {
        slideChange() {
          setActive(this.activeIndex);
        },
      },
    });

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const index = Number(tab.dataset.moducubeFitIndex || 0);
        swiper.slideTo(index);
        setActive(index);
      });
    });

    setActive(swiper.activeIndex);
  }

  function initUgcStories(section) {
    if (section.dataset.moducubeUgcInitialized === 'true') return;

    const swiperElement = section.querySelector('[data-moducube-ugc-swiper]');
    const videos = Array.from(section.querySelectorAll('[data-moducube-ugc-video]'));
    const progressItems = Array.from(section.querySelectorAll('[data-moducube-ugc-progress]'));
    const previousButton = section.querySelector('[data-moducube-ugc-prev]');
    const nextButton = section.querySelector('[data-moducube-ugc-next]');

    if (!swiperElement || videos.length === 0 || progressItems.length === 0) return;

    if (!window.Swiper) {
      const retryCount = Number(section.dataset.moducubeUgcRetryCount || 0);

      if (retryCount < 50) {
        section.dataset.moducubeUgcRetryCount = String(retryCount + 1);
        window.setTimeout(() => initUgcStories(section), 100);
      }

      return;
    }

    section.dataset.moducubeUgcInitialized = 'true';

    const mobilePlaybackQuery = window.matchMedia('(max-width: 989px)');
    let sectionInView = false;
    let playbackTimer;

    function clearPlaybackTimer() {
      window.clearTimeout(playbackTimer);
      playbackTimer = undefined;
    }

    function setProgress(index, progress) {
      progressItems.forEach((item, itemIndex) => {
        const isComplete = itemIndex < index;
        const isActive = itemIndex === index;
        const progressValue = isActive ? Math.max(0, Math.min(100, progress)) : 0;

        item.classList.toggle('is-complete', isComplete);
        item.classList.toggle('is-active', isActive);
        item.style.setProperty('--moducube-ugc-progress', `${progressValue}%`);
      });
    }

    function updateControls(swiper) {
      if (!swiper) return;

      if (previousButton) previousButton.disabled = false;
      if (nextButton) nextButton.disabled = false;
    }

    function getSectionVideos() {
      return Array.from(section.querySelectorAll('[data-moducube-ugc-video]'));
    }

    function getActiveVideo(swiper) {
      const activeSlide = swiper && swiper.slides ? swiper.slides[swiper.activeIndex] : null;

      return activeSlide ? activeSlide.querySelector('[data-moducube-ugc-video]') : null;
    }

    function getLogicalIndex(swiper) {
      const activeVideo = getActiveVideo(swiper);
      const videoIndex = activeVideo ? Number(activeVideo.dataset.moducubeUgcVideoIndex) : Number.NaN;

      if (Number.isInteger(videoIndex)) return videoIndex;
      if (Number.isInteger(swiper.realIndex)) return swiper.realIndex;

      return swiper.activeIndex;
    }

    function pauseInactiveVideos(activeVideo) {
      getSectionVideos().forEach((video) => {
        if (video === activeVideo) return;

        const card = video.closest('.moducube-ugc__card');

        if (card) card.classList.remove('is-playing');
        video.pause();
        video.currentTime = 0;
      });
    }

    function startVideo(swiper, video) {
      if (!video || getActiveVideo(swiper) !== video || !sectionInView || document.hidden) return;

      video.muted = true;
      video.playsInline = true;

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    function playActiveVideo(swiper) {
      clearPlaybackTimer();

      const activeVideo = getActiveVideo(swiper);

      pauseInactiveVideos(activeVideo);
      if (!activeVideo || !sectionInView || document.hidden) return;

      const card = activeVideo.closest('.moducube-ugc__card');

      activeVideo.pause();
      activeVideo.currentTime = 0;
      if (card) card.classList.remove('is-playing');

      if (mobilePlaybackQuery.matches) {
        playbackTimer = window.setTimeout(() => {
          playbackTimer = undefined;
          startVideo(swiper, activeVideo);
        }, 1000);
      } else {
        startVideo(swiper, activeVideo);
      }
    }

    function activate(swiper) {
      setProgress(getLogicalIndex(swiper), 0);
      playActiveVideo(swiper);
    }

    function bindVideoEvents(swiper) {
      getSectionVideos().forEach((video) => {
        if (video.dataset.moducubeUgcEventsBound === 'true') return;

        video.dataset.moducubeUgcEventsBound = 'true';

        video.addEventListener('loadedmetadata', () => {
          if (getActiveVideo(swiper) !== video) return;

          setProgress(getLogicalIndex(swiper), 0);
        });

        video.addEventListener(
          'timeupdate',
          () => {
            if (getActiveVideo(swiper) !== video || !video.duration) return;

            setProgress(getLogicalIndex(swiper), (video.currentTime / video.duration) * 100);
          },
          { passive: true }
        );

        video.addEventListener('ended', () => {
          if (getActiveVideo(swiper) !== video) return;

          const card = video.closest('.moducube-ugc__card');

          if (card) card.classList.remove('is-playing');
          goToNext();
        });

        video.addEventListener('play', () => {
          const card = video.closest('.moducube-ugc__card');

          if (card) card.classList.add('is-playing');
        });

        video.addEventListener('pause', () => {
          const card = video.closest('.moducube-ugc__card');

          if (card) card.classList.remove('is-playing');
        });
      });
    }

    const swiper = new window.Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: true,
      breakpoints: {
        990: {
          spaceBetween: 18,
        },
      },
      speed: 350,
      threshold: 8,
      allowTouchMove: true,
      on: {
        init() {
          bindVideoEvents(this);
          updateControls(this);
        },
        slideChange() {
          bindVideoEvents(this);
          activate(this);
          updateControls(this);
        },
        resize() {
          this.update();
          updateControls(this);
        },
      },
    });

    bindVideoEvents(swiper);

    function goToPrevious() {
      swiper.slidePrev();
    }

    function goToNext() {
      swiper.slideNext();
    }

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        goToPrevious();
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        goToNext();
      });
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearPlaybackTimer();
        pauseInactiveVideos(null);
      } else {
        playActiveVideo(swiper);
      }
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          sectionInView = Boolean(entry && entry.isIntersecting);

          if (sectionInView) {
            playActiveVideo(swiper);
          } else {
            clearPlaybackTimer();
            pauseInactiveVideos(null);
          }
        },
        { threshold: 0.45 }
      );

      observer.observe(section);
    } else {
      sectionInView = true;
    }

    if (mobilePlaybackQuery.addEventListener) {
      mobilePlaybackQuery.addEventListener('change', () => {
        playActiveVideo(swiper);
      });
    }

    activate(swiper);
    updateControls(swiper);
  }

  function initFaq(faq) {
    if (!faq || faq.dataset.moducubeFaqInitialized === 'true') return;

    const items = Array.from(faq.querySelectorAll('.moducube-faq__item'));
    if (items.length === 0) return;

    faq.dataset.moducubeFaqInitialized = 'true';

    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    let reserveTimer;

    function getAnswer(item) {
      return item.querySelector('.moducube-faq__answer');
    }

    function resetAnswer(answer) {
      if (!answer) return;

      answer.style.height = '';
      answer.style.opacity = '';
      answer.style.overflow = '';
    }

    function closeOtherItems(activeItem) {
      items.forEach((otherItem) => {
        if (otherItem !== activeItem) {
          closeItem(otherItem);
        }
      });
    }

    function reserveFaqHeight() {
      const openStates = items.map((item) => item.open);
      let reservedHeight = faq.getBoundingClientRect().height;

      items.forEach((item) => {
        item.classList.remove('is-animating', 'is-closing');
        resetAnswer(getAnswer(item));
        item.open = false;
      });

      reservedHeight = Math.max(reservedHeight, faq.getBoundingClientRect().height);

      items.forEach((item) => {
        item.open = true;
        resetAnswer(getAnswer(item));
        reservedHeight = Math.max(reservedHeight, faq.getBoundingClientRect().height);
        item.open = false;
      });

      items.forEach((item, index) => {
        item.open = openStates[index];
      });

      faq.style.setProperty('--moducube-faq-reserved-height', `${Math.ceil(reservedHeight)}px`);
    }

    function scheduleFaqHeightReserve() {
      window.clearTimeout(reserveTimer);
      reserveTimer = window.setTimeout(reserveFaqHeight, 120);
    }

    function openItem(item) {
      const answer = getAnswer(item);

      if (item.open || !answer) return;

      closeOtherItems(item);

      if (reduceMotionQuery.matches) {
        item.open = true;
        return;
      }

      item.open = true;
      item.classList.remove('is-closing');
      item.classList.add('is-animating');

      answer.style.height = '0px';
      answer.style.opacity = '0';
      answer.style.overflow = 'hidden';

      window.requestAnimationFrame(() => {
        answer.style.height = `${answer.scrollHeight}px`;
        answer.style.opacity = '1';
      });

      const handleOpenTransitionEnd = (event) => {
        if (event.propertyName !== 'height' || !item.open) return;

        answer.removeEventListener('transitionend', handleOpenTransitionEnd);
        item.classList.remove('is-animating');
        resetAnswer(answer);
      };

      answer.addEventListener('transitionend', handleOpenTransitionEnd);
    }

    function closeItem(item) {
      const answer = getAnswer(item);

      if (!item.open || !answer) return;

      if (reduceMotionQuery.matches) {
        item.open = false;
        return;
      }

      item.classList.add('is-animating', 'is-closing');
      answer.style.height = `${answer.scrollHeight}px`;
      answer.style.opacity = '1';
      answer.style.overflow = 'hidden';

      window.requestAnimationFrame(() => {
        answer.style.height = '0px';
        answer.style.opacity = '0';
      });

      const handleCloseTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;

        answer.removeEventListener('transitionend', handleCloseTransitionEnd);
        item.open = false;
        item.classList.remove('is-animating', 'is-closing');
        resetAnswer(answer);
      };

      answer.addEventListener('transitionend', handleCloseTransitionEnd);
    }

    items.forEach((item) => {
      const summary = item.querySelector('.moducube-faq__question');

      if (!summary) return;

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (item.open) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });

    reserveFaqHeight();
    window.addEventListener('load', reserveFaqHeight, { once: true });
    window.addEventListener('resize', scheduleFaqHeightReserve, { passive: true });
  }

  function initExtendedStickyPurchase(hero) {
    if (!hero || hero.dataset.moducubeExtendedStickyInitialized === 'true') return;

    const stickyColumn = hero.querySelector('.moducube-product-hero__content-column');
    const stickyContent = hero.querySelector('.moducube-product-hero__content');
    const benefitsCards = document.querySelector('.moducube-benefits__cards');
    const ugcSection = document.querySelector('.moducube-ugc');

    if (!stickyColumn || !stickyContent || !ugcSection) return;

    hero.dataset.moducubeExtendedStickyInitialized = 'true';

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let resizeTimer;
    let stickyTop = 0;
    let columnTop = 0;
    let stopTop = 0;
    let contentHeight = 0;
    let columnWidth = 0;
    let frameRequested = false;

    function clearManagedPosition() {
      stickyContent.style.position = '';
      stickyContent.style.top = '';
      stickyContent.style.right = '';
      stickyContent.style.bottom = '';
      stickyContent.style.left = '';
      stickyContent.style.width = '';
    }

    function setStaticPosition() {
      stickyContent.style.position = 'static';
      stickyContent.style.top = '';
      stickyContent.style.right = '';
      stickyContent.style.bottom = '';
      stickyContent.style.left = '';
      stickyContent.style.width = '';
    }

    function getStickyTop() {
      const headerHeight = Number.parseFloat(
        window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')
      );

      return Math.round((Number.isFinite(headerHeight) && headerHeight > 0 ? headerHeight : 80) + 40);
    }

    function getStopTop() {
      const scrollY = window.scrollY || window.pageYOffset;

      if (benefitsCards) {
        return benefitsCards.getBoundingClientRect().bottom + scrollY;
      }

      return ugcSection.getBoundingClientRect().top + scrollY - 56;
    }

    function updateManagedPosition() {
      if (!desktopQuery.matches) {
        clearManagedPosition();
        return;
      }

      const scrollY = window.scrollY || window.pageYOffset;
      const columnRect = stickyColumn.getBoundingClientRect();
      const fixedTop = stickyTop;
      stopTop = getStopTop();
      const fixedBottom = scrollY + fixedTop + contentHeight;

      columnWidth = columnRect.width;

      if (scrollY + fixedTop <= columnTop) {
        setStaticPosition();
        return;
      }

      if (fixedBottom >= stopTop) {
        stickyContent.style.position = 'absolute';
        stickyContent.style.top = `${Math.max(0, stopTop - columnTop - contentHeight)}px`;
        stickyContent.style.right = '';
        stickyContent.style.bottom = '';
        stickyContent.style.left = '0px';
        stickyContent.style.width = `${columnWidth}px`;
        return;
      }

      stickyContent.style.position = 'fixed';
      stickyContent.style.top = `${fixedTop}px`;
      stickyContent.style.right = '';
      stickyContent.style.bottom = '';
      stickyContent.style.left = `${columnRect.left}px`;
      stickyContent.style.width = `${columnWidth}px`;
    }

    function updateStickyMeasurements() {
      setStaticPosition();

      if (!desktopQuery.matches) {
        clearManagedPosition();
        return;
      }

      const scrollY = window.scrollY || window.pageYOffset;
      const columnTopNext = stickyColumn.getBoundingClientRect().top + scrollY;

      const columnRect = stickyColumn.getBoundingClientRect();

      stickyTop = getStickyTop();
      columnTop = columnTopNext;
      stopTop = getStopTop();
      contentHeight = stickyContent.offsetHeight;
      columnWidth = columnRect.width;

      updateManagedPosition();
    }

    function scheduleStickyMeasurementsUpdate() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateStickyMeasurements, 120);
    }

    function scheduleManagedPositionUpdate() {
      if (frameRequested) return;

      frameRequested = true;
      window.requestAnimationFrame(() => {
        frameRequested = false;
        updateManagedPosition();
      });
    }

    updateStickyMeasurements();
    window.addEventListener('load', updateStickyMeasurements, { once: true });
    window.addEventListener('resize', scheduleStickyMeasurementsUpdate, { passive: true });
    window.addEventListener('scroll', scheduleManagedPositionUpdate, { passive: true });
    window.setTimeout(updateStickyMeasurements, 500);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateStickyMeasurements).catch(() => {});
    }

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', updateStickyMeasurements);
    }
  }

  function initMobileStickyAtc(hero) {
    if (!hero || hero.dataset.moducubeMobileStickyAtcInitialized === 'true') return;

    const stickyAtc = hero.querySelector('[data-moducube-sticky-atc]');
    const trustList = hero.querySelector('.moducube-product-hero__trust-list');
    const primaryAddButton = hero.querySelector('.moducube-product-hero__add-button');
    const coverCta = document.querySelector('.moducube-cover-cta');

    if (!stickyAtc || !trustList || !primaryAddButton || !coverCta) return;

    hero.dataset.moducubeMobileStickyAtcInitialized = 'true';

    const mobileQuery = window.matchMedia('(max-width: 989px)');
    const desktopQuery = window.matchMedia('(min-width: 990px)');
    let previousScrollY = window.scrollY || window.pageYOffset || 0;
    let scrollDirection = 'none';
    let scrollDirectionStartY = previousScrollY;
    let hideAfterUpwardScroll = false;
    let frameRequested = false;
    const upwardScrollHideThreshold = 48;

    function setVisible(isVisible) {
      stickyAtc.classList.toggle('is-visible', isVisible);
      stickyAtc.setAttribute('aria-hidden', String(!isVisible));
    }

    function readScrollDirection() {
      const currentScrollY = window.scrollY || window.pageYOffset || 0;

      if (currentScrollY > previousScrollY + 1) {
        if (scrollDirection !== 'down') {
          scrollDirection = 'down';
          scrollDirectionStartY = previousScrollY;
        }

        hideAfterUpwardScroll = false;
      } else if (currentScrollY < previousScrollY - 1) {
        if (scrollDirection !== 'up') {
          scrollDirection = 'up';
          scrollDirectionStartY = previousScrollY;
        }

        hideAfterUpwardScroll =
          Math.max(0, scrollDirectionStartY - currentScrollY) >= upwardScrollHideThreshold;
      }

      previousScrollY = currentScrollY;
    }

    function updateStickyAtc() {
      if (!mobileQuery.matches && !desktopQuery.matches) {
        setVisible(false);
        return;
      }

      const trustListRect = trustList.getBoundingClientRect();
      const primaryAddButtonRect = primaryAddButton.getBoundingClientRect();
      const coverCtaRect = coverCta.getBoundingClientRect();
      const trustListPassed = trustListRect.bottom <= 0;
      const primaryAddButtonVisible = primaryAddButtonRect.bottom > 0 && primaryAddButtonRect.top < window.innerHeight;
      const coverCtaReached = mobileQuery.matches && coverCtaRect.top <= window.innerHeight;

      if (desktopQuery.matches) {
        hideAfterUpwardScroll = false;
        setVisible(!primaryAddButtonVisible);
        return;
      }

      setVisible(
        trustListPassed &&
          !primaryAddButtonVisible &&
          !coverCtaReached &&
          !hideAfterUpwardScroll
      );
    }

    function scheduleStickyAtcUpdate() {
      readScrollDirection();

      if (frameRequested) return;

      frameRequested = true;
      window.requestAnimationFrame(() => {
        frameRequested = false;
        updateStickyAtc();
      });
    }

    updateStickyAtc();
    window.addEventListener('scroll', scheduleStickyAtcUpdate, { passive: true });
    window.addEventListener('resize', scheduleStickyAtcUpdate, { passive: true });

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', updateStickyAtc);
    }

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', updateStickyAtc);
    }
  }

  function initDeliveryEstimate(estimate) {
    if (!estimate || estimate.dataset.moducubeDeliveryEstimateInitialized === 'true') return;

    estimate.dataset.moducubeDeliveryEstimateInitialized = 'true';

    function isBusinessDay(date) {
      const day = date.getDay();

      return day !== 0 && day !== 6;
    }

    function addBusinessDays(date, days) {
      const nextDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      let remainingDays = days;

      while (remainingDays > 0) {
        nextDate.setDate(nextDate.getDate() + 1);

        if (isBusinessDay(nextDate)) {
          remainingDays -= 1;
        }
      }

      return nextDate;
    }

    function formatMonth(date) {
      return date.toLocaleString('en-US', { month: 'short' });
    }

    function formatDeliveryRange(startDate, endDate) {
      const startMonth = formatMonth(startDate);
      const endMonth = formatMonth(endDate);
      const startDay = startDate.getDate();
      const endDay = endDate.getDate();

      if (startMonth === endMonth) {
        return `${startMonth} ${startDay}-${endDay}`;
      }

      return `${startMonth} ${startDay}-${endMonth} ${endDay}`;
    }

    const today = new Date();
    const earliestDeliveryDate = addBusinessDays(today, 3);
    const latestDeliveryDate = addBusinessDays(today, 5);

    estimate.textContent = `Order now and get it by: ${formatDeliveryRange(earliestDeliveryDate, latestDeliveryDate)}`;
  }

  function initAssemblyVideo(video) {
    if (!video || video.dataset.moducubeAssemblyVideoInitialized === 'true') return;

    video.dataset.moducubeAssemblyVideoInitialized = 'true';
    video.defaultMuted = true;
    video.muted = true;

    const playVideo = () => {
      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    video.addEventListener('canplay', playVideo, { once: true });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && video.paused) playVideo();
    });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting) && video.paused) playVideo();
        },
        { threshold: 0.1 }
      );

      observer.observe(video);
    }

    playVideo();
  }

  function initComparisonTable(scrollArea) {
    if (!scrollArea || scrollArea.dataset.moducubeComparisonInitialized === 'true') return;

    const section = scrollArea.closest('.moducube-comparison');
    const scrollbar = section?.querySelector('[data-moducube-comparison-scrollbar]');
    const thumb = scrollbar?.querySelector('[data-moducube-comparison-scrollbar-thumb]');
    const mobileQuery = window.matchMedia('(max-width: 989px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!section || !scrollbar || !thumb) return;

    scrollArea.dataset.moducubeComparisonInitialized = 'true';

    let cueStarted = false;
    let cueCancelled = false;
    let cueQueued = false;
    let animationTimer;
    let gestureStart;

    const getMaxScroll = () => Math.max(0, scrollArea.scrollWidth - scrollArea.clientWidth);

    const updateScrollbar = () => {
      const maxScroll = getMaxScroll();
      const trackWidth = scrollbar.clientWidth;
      const thumbWidth = maxScroll > 0
        ? Math.max(48, trackWidth * (scrollArea.clientWidth / scrollArea.scrollWidth))
        : trackWidth;
      const maxThumbTravel = Math.max(0, trackWidth - thumbWidth);
      const progress = maxScroll > 0 ? scrollArea.scrollLeft / maxScroll : 0;

      thumb.style.width = `${thumbWidth}px`;
      thumb.style.transform = `translateX(${maxThumbTravel * progress}px)`;
    };

    const cancelCue = () => {
      cueCancelled = true;
      window.clearInterval(animationTimer);
    };

    const animateTo = (target, duration) => new Promise((resolve) => {
      const start = scrollArea.scrollLeft;
      const distance = target - start;
      const startedAt = Date.now();

      const step = () => {
        if (cueCancelled) {
          window.clearInterval(animationTimer);
          resolve();
          return;
        }

        const progress = Math.min((Date.now() - startedAt) / duration, 1);
        const eased = 0.5 - Math.cos(progress * Math.PI) / 2;

        scrollArea.scrollLeft = start + distance * eased;
        updateScrollbar();

        if (progress >= 1) {
          window.clearInterval(animationTimer);
          resolve();
        }
      };

      animationTimer = window.setInterval(step, 16);
      step();
    });

    const runCue = async () => {
      if (
        cueStarted ||
        cueCancelled ||
        !mobileQuery.matches ||
        reduceMotionQuery.matches ||
        scrollArea.scrollLeft > 2
      ) return;

      const maxScroll = getMaxScroll();
      if (maxScroll <= 0) return;

      cueStarted = true;
      const cueDistance = Math.min(maxScroll, Math.max(24, scrollArea.scrollWidth * 0.05));

      for (let cycle = 0; cycle < 2 && !cueCancelled; cycle += 1) {
        await animateTo(cueDistance, 420);
        await animateTo(0, 420);
      }

    };

    const setScrollFromPointer = (clientX) => {
      const rect = scrollbar.getBoundingClientRect();
      const maxScroll = getMaxScroll();
      const progress = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));

      scrollArea.scrollLeft = maxScroll * progress;
      updateScrollbar();
    };

    scrollbar.addEventListener('pointerdown', (event) => {
      cancelCue();
      scrollbar.setPointerCapture(event.pointerId);
      setScrollFromPointer(event.clientX);

      const handlePointerMove = (moveEvent) => setScrollFromPointer(moveEvent.clientX);
      const handlePointerUp = (upEvent) => {
        scrollbar.releasePointerCapture(upEvent.pointerId);
        scrollbar.removeEventListener('pointermove', handlePointerMove);
        scrollbar.removeEventListener('pointerup', handlePointerUp);
        scrollbar.removeEventListener('pointercancel', handlePointerUp);
      };

      scrollbar.addEventListener('pointermove', handlePointerMove);
      scrollbar.addEventListener('pointerup', handlePointerUp);
      scrollbar.addEventListener('pointercancel', handlePointerUp);
    });

    scrollArea.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse') {
        cancelCue();
        return;
      }

      gestureStart = { x: event.clientX, y: event.clientY };
    }, { passive: true });
    scrollArea.addEventListener('pointermove', (event) => {
      if (!gestureStart) return;

      const horizontalTravel = Math.abs(event.clientX - gestureStart.x);
      const verticalTravel = Math.abs(event.clientY - gestureStart.y);

      if (horizontalTravel > 10 && horizontalTravel > verticalTravel) cancelCue();
    }, { passive: true });
    ['pointerup', 'pointercancel'].forEach((eventName) => {
      scrollArea.addEventListener(eventName, () => {
        gestureStart = undefined;
      }, { passive: true });
    });
    scrollArea.addEventListener('wheel', (event) => {
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) cancelCue();
    }, { passive: true });
    scrollArea.addEventListener('keydown', (event) => {
      if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) cancelCue();
    });
    scrollArea.addEventListener('scroll', updateScrollbar, { passive: true });
    window.addEventListener('resize', updateScrollbar);

    const startCueWhenVisible = () => {
      const rect = section.getBoundingClientRect();
      const visibleHeight = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
      const visibilityTarget = Math.min(rect.height, window.innerHeight) * 0.35;

      if (visibleHeight < visibilityTarget) return false;

      if (!cueQueued) {
        cueQueued = true;
        window.setTimeout(runCue, 300);
      }

      return true;
    };

    let observer;
    let visibilityPoll;

    const stopVisibilityWatch = () => {
      observer?.disconnect();
      window.clearInterval(visibilityPoll);
    };

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          startCueWhenVisible();
          stopVisibilityWatch();
        },
        { threshold: 0.35 }
      );

      observer.observe(section);
    }

    visibilityPoll = window.setInterval(() => {
      if (startCueWhenVisible()) stopVisibilityWatch();
    }, 250);
    if (startCueWhenVisible()) stopVisibilityWatch();

    updateScrollbar();
  }

  function initOldWayPinnedScroll(section) {
    if (!section || section.dataset.moducubeOldWayInitialized === 'true') return;

    const desktopQuery = window.matchMedia('(min-width: 990px)');
    const reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const cards = section.querySelector('.moducube-old-way__cards');
    const card = section.querySelector('.moducube-old-way__card');
    const pairs = Array.from(section.querySelectorAll('[data-moducube-old-way-pair]'));
    const images = Array.from(section.querySelectorAll('[data-moducube-old-way-image]'));
    const dots = Array.from(section.querySelectorAll('.moducube-old-way__rail-dot'));
    const stepCount = section.querySelector('[data-moducube-old-way-step]');

    if (!cards || !card || !pairs.length || !images.length) return;

    section.dataset.moducubeOldWayInitialized = 'true';

    let activeStepIndex = -1;
    let activePhaseIndex = -1;
    let breadcrumbFlashTimeout;
    let scrollTriggerInstance;
    let fallbackTimer;
    let nativeScrollActive = false;
    let nativeScrollRaf;
    let nativeTickerRaf;
    let lastProgress = 0;

    const getStickyTop = () => {
      const value = window.getComputedStyle(section).getPropertyValue('--moducube-old-way-sticky-top').trim();
      const parsed = Number.parseFloat(value);

      return Number.isFinite(parsed) ? parsed : getStickyHeaderOffset() + 40;
    };

    const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
    const smoothStep = (value) => {
      const clamped = clamp(value);
      return clamped * clamped * (3 - 2 * clamped);
    };

    const triggerBreadcrumbFlash = (dot) => {
      if (!dot) return;

      window.clearTimeout(breadcrumbFlashTimeout);
      dots.forEach((railDot) => railDot.classList.remove('is-flashing'));
      dot.offsetWidth;
      dot.classList.add('is-flashing');
      breadcrumbFlashTimeout = window.setTimeout(() => {
        dot.classList.remove('is-flashing');
      }, 900);
    };

    const setVisualState = (stepIndex, phaseIndex) => {
      const normalizedStepIndex = Math.min(pairs.length - 1, Math.max(0, stepIndex));
      const normalizedPhaseIndex = phaseIndex === 1 ? 1 : 0;

      pairs.forEach((pair, pairIndex) => {
        const isActivePair = pairIndex === normalizedStepIndex;

        pair.classList.toggle('is-active', isActivePair);
        pair.classList.toggle('is-old-active', isActivePair && normalizedPhaseIndex === 0);
        pair.classList.toggle('is-new-active', isActivePair && normalizedPhaseIndex === 1);
      });

      images.forEach((image, imageIndex) => {
        image.classList.toggle('is-active', imageIndex === normalizedStepIndex);
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === normalizedStepIndex);
      });

      section.classList.toggle('is-moducube-way-active', normalizedPhaseIndex === 1);
      section.style.setProperty('--moducube-old-way-phase', String(normalizedPhaseIndex));
      section.style.setProperty('--moducube-old-way-progress', String(normalizedStepIndex + normalizedPhaseIndex));

      if (stepCount) {
        stepCount.textContent = String(normalizedStepIndex + 1).padStart(2, '0');
      }
    };

    const setElementPosition = (element, yPercent, opacity = 1, animate = false) => {
      if (!element) return;

      const normalizedY = Math.round(yPercent * 1000) / 1000;
      const normalizedOpacity = Math.round(opacity * 1000) / 1000;
      const targetKey = `${normalizedY}:${normalizedOpacity}`;

      if (animate && element._moducubeOldWayTarget === targetKey) return;
      element._moducubeOldWayTarget = targetKey;

      if (window.gsap) {
        window.gsap.killTweensOf(element, 'y,yPercent,autoAlpha');

        if (animate) {
          window.gsap.to(element, {
            y: 0,
            yPercent: normalizedY,
            autoAlpha: normalizedOpacity,
            duration: 0.62,
            ease: 'power2.out',
            overwrite: 'auto',
          });
          return;
        }

        window.gsap.set(element, {
          y: 0,
          yPercent: normalizedY,
          autoAlpha: normalizedOpacity,
          overwrite: 'auto',
        });
        return;
      }

      const targetTransform = `translate3d(0, ${normalizedY}%, 0)`;
      const targetVisibility = normalizedOpacity > 0 ? 'visible' : 'hidden';

      element.style.transition = 'none';

      if (element._moducubeOldWayRaf) {
        window.cancelAnimationFrame(element._moducubeOldWayRaf);
        element._moducubeOldWayRaf = null;
      }

      if (animate) {
        const duration = 620;
        const startY = Number.isFinite(element._moducubeOldWayY)
          ? element._moducubeOldWayY
          : normalizedY;
        const startOpacity = Number.isFinite(element._moducubeOldWayOpacity)
          ? element._moducubeOldWayOpacity
          : Number.parseFloat(window.getComputedStyle(element).opacity) || 1;
        const deltaY = normalizedY - startY;
        const deltaOpacity = normalizedOpacity - startOpacity;
        let startTime;

        element.style.visibility = 'visible';
        const tick = (timestamp) => {
          if (!startTime) startTime = timestamp;

          const elapsed = timestamp - startTime;
          const progress = clamp(elapsed / duration);
          const eased = 1 - Math.pow(1 - progress, 3);
          const currentY = startY + deltaY * eased;
          const currentOpacity = startOpacity + deltaOpacity * eased;

          element._moducubeOldWayY = currentY;
          element._moducubeOldWayOpacity = currentOpacity;
          element.style.transform = `translate3d(0, ${currentY}%, 0)`;
          element.style.opacity = String(currentOpacity);

          if (progress < 1) {
            element._moducubeOldWayRaf = window.requestAnimationFrame(tick);
            return;
          }

          element.style.transform = targetTransform;
          element.style.opacity = String(normalizedOpacity);
          element.style.visibility = targetVisibility;
          element._moducubeOldWayY = normalizedY;
          element._moducubeOldWayOpacity = normalizedOpacity;
          element._moducubeOldWayRaf = null;
        };

        element._moducubeOldWayRaf = window.requestAnimationFrame(tick);
        return;
      }

      element.style.transform = targetTransform;
      element.style.opacity = String(normalizedOpacity);
      element.style.visibility = targetVisibility;
      element._moducubeOldWayY = normalizedY;
      element._moducubeOldWayOpacity = normalizedOpacity;
    };

    const setPanelPairState = (pair, newProgress, direction, animate = false) => {
      if (!pair) return;

      const oldPanel = pair.querySelector('.moducube-old-way__panel--old');
      const newPanel = pair.querySelector('.moducube-old-way__panel--new');
      if (!oldPanel || !newPanel) return;

      const easedProgress = smoothStep(newProgress);
      const oldOpacity = 1 - easedProgress * 0.82;
      const newStart = 100;

      setElementPosition(oldPanel, -18 * easedProgress, oldOpacity, animate);
      setElementPosition(newPanel, newStart * (1 - easedProgress), 1, animate);
    };

    const resetPanelPositions = (pair, phaseIndex) => {
      if (!pair) return;

      setPanelPairState(pair, phaseIndex === 1 ? 1 : 0, 1, false);
    };

    const clearPanelPositions = (pair) => {
      if (!pair) return;

      const oldPanel = pair.querySelector('.moducube-old-way__panel--old');
      const newPanel = pair.querySelector('.moducube-old-way__panel--new');
      const panels = [oldPanel, newPanel].filter(Boolean);

      if (window.gsap) {
        window.gsap.killTweensOf(panels);
        window.gsap.set(panels, { clearProps: 'transform,opacity,visibility,filter,animation' });
        return;
      }

      panels.forEach((panel) => {
        panel.style.removeProperty('transform');
        panel.style.removeProperty('opacity');
        panel.style.removeProperty('visibility');
        panel.style.removeProperty('filter');
        panel.style.removeProperty('animation');
      });
    };

    const resetMobileState = () => {
      pairs.forEach((pair) => {
        pair.classList.remove('is-active', 'is-old-active', 'is-new-active');
        clearPanelPositions(pair);
      });

      images.forEach((image, imageIndex) => {
        image.classList.toggle('is-active', imageIndex === 0);
      });

      dots.forEach((dot) => {
        dot.classList.remove('is-active', 'is-flashing');
      });

      if (stepCount) stepCount.textContent = '01';
      section.classList.remove('is-moducube-way-active');
      section.style.removeProperty('--moducube-old-way-phase');
      section.style.removeProperty('--moducube-old-way-progress');
      activeStepIndex = -1;
      activePhaseIndex = -1;
    };

    const getNativeProgress = () => {
      const scrollY = window.scrollY || window.pageYOffset || 0;
      const stickyTop = getStickyTop();
      const cardsTop = cards.getBoundingClientRect().top + scrollY;
      const scrollRange = Math.max(1, cards.offsetHeight - card.offsetHeight);

      return clamp((scrollY - cardsTop + stickyTop) / scrollRange);
    };

    const updateNativeProgress = (animate = true) => {
      updateFromProgress(getNativeProgress(), { animate });
    };

    const onNativeScroll = () => {
      if (nativeScrollRaf) return;

      nativeScrollRaf = window.requestAnimationFrame(() => {
        nativeScrollRaf = null;
        updateNativeProgress(true);
      });
    };

    const startNativeTicker = () => {
      if (nativeTickerRaf) return;

      const tick = () => {
        if (!nativeScrollActive) {
          nativeTickerRaf = null;
          return;
        }

        updateNativeProgress(false);
        nativeTickerRaf = window.requestAnimationFrame(tick);
      };

      nativeTickerRaf = window.requestAnimationFrame(tick);
    };

    const stopNativeScroll = () => {
      if (!nativeScrollActive) return;

      window.removeEventListener('scroll', onNativeScroll);
      window.removeEventListener('resize', onNativeScroll);
      if (nativeScrollRaf) {
        window.cancelAnimationFrame(nativeScrollRaf);
        nativeScrollRaf = null;
      }

      if (nativeTickerRaf) {
        window.cancelAnimationFrame(nativeTickerRaf);
        nativeTickerRaf = null;
      }

      section.removeAttribute('data-moducube-old-way-native');
      nativeScrollActive = false;
    };

    const setActiveState = (stepIndex, phaseIndex) => {
      const normalizedStepIndex = Math.min(pairs.length - 1, Math.max(0, stepIndex));
      const normalizedPhaseIndex = phaseIndex === 1 ? 1 : 0;
      const stepChanged = activeStepIndex !== normalizedStepIndex;

      setVisualState(normalizedStepIndex, normalizedPhaseIndex);

      if (stepChanged && activeStepIndex !== -1) {
        triggerBreadcrumbFlash(dots[normalizedStepIndex]);
      }

      activeStepIndex = normalizedStepIndex;
      activePhaseIndex = normalizedPhaseIndex;
    };

    const updateFromProgress = (rawProgress, options = {}) => {
      const progress = clamp(rawProgress);
      const direction = progress >= lastProgress ? 1 : -1;
      const stateCount = pairs.length * 2;
      const maxStatePosition = stateCount - 1;
      const rawStatePosition = progress * maxStatePosition;

      if (!desktopQuery.matches) {
        const reducedStateIndex = Math.min(maxStatePosition, Math.max(0, Math.round(rawStatePosition)));
        const visualStepIndex = Math.floor(reducedStateIndex / 2);
        const visualPhaseIndex = reducedStateIndex % 2;

        setActiveState(visualStepIndex, visualPhaseIndex);

        pairs.forEach((pair, pairIndex) => {
          const isCurrent = pairIndex === visualStepIndex;
          pair.classList.toggle('is-active', isCurrent);
          resetPanelPositions(pair, isCurrent ? visualPhaseIndex : 0);
        });

        images.forEach((image, imageIndex) => {
          image.classList.toggle('is-active', imageIndex === visualStepIndex);
        });

        lastProgress = progress;
        return;
      }

      const baseStatePosition = progress >= 1
        ? maxStatePosition
        : Math.min(maxStatePosition, Math.floor(rawStatePosition));
      const localStateProgress = rawStatePosition - baseStatePosition;
      const transitionStart = 0.32;
      const transitionEnd = 0.88;
      let easedLocalProgress = 0;

      if (localStateProgress >= transitionEnd) {
        easedLocalProgress = 1;
      } else if (localStateProgress > transitionStart) {
        easedLocalProgress = smoothStep((localStateProgress - transitionStart) / (transitionEnd - transitionStart));
      }

      const effectiveStatePosition = Math.min(maxStatePosition, baseStatePosition + easedLocalProgress);
      const effectiveBaseState = Math.floor(effectiveStatePosition);
      const effectiveLocalState = effectiveStatePosition - effectiveBaseState;
      const pairTrack = effectiveBaseState % 2 === 0
        ? effectiveBaseState / 2
        : Math.min(pairs.length - 1, Math.floor(effectiveBaseState / 2) + effectiveLocalState);
      const activeStateIndex = Math.min(maxStatePosition, Math.max(0, Math.round(effectiveStatePosition)));
      const activeVisualStep = Math.floor(activeStateIndex / 2);
      const activeVisualPhase = activeStateIndex % 2;
      const stepChanged = activeStepIndex !== activeVisualStep;

      setVisualState(activeVisualStep, activeVisualPhase);

      if (stepChanged && activeStepIndex !== -1) {
        triggerBreadcrumbFlash(dots[activeVisualStep]);
      }

      activeStepIndex = activeVisualStep;
      activePhaseIndex = activeVisualPhase;

      pairs.forEach((pair, pairIndex) => {
        const yPercent = (pairIndex - pairTrack) * 100;
        const pairNewProgress = clamp(effectiveStatePosition - pairIndex * 2);

        const isVisible = Math.abs(yPercent) < 100;
        setElementPosition(pair, yPercent, isVisible ? 1 : 0, false);
        pair.classList.toggle('is-active', isVisible && pairIndex === activeVisualStep);
        pair.classList.toggle('is-old-active', isVisible && pairIndex === activeVisualStep && activeVisualPhase === 0);
        pair.classList.toggle('is-new-active', isVisible && pairIndex === activeVisualStep && activeVisualPhase === 1);
        setPanelPairState(pair, pairNewProgress, direction, false);
      });

      images.forEach((image, imageIndex) => {
        const yPercent = (imageIndex - pairTrack) * 100;

        const isVisible = Math.abs(yPercent) < 100;
        setElementPosition(image, yPercent, isVisible ? 1 : 0, false);
        image.classList.toggle('is-active', isVisible && imageIndex === activeVisualStep);
      });

      lastProgress = progress;
    };

    const destroyScrollTrigger = () => {
      if (scrollTriggerInstance) {
        scrollTriggerInstance.kill();
        scrollTriggerInstance = null;
      }
    };

    const startNativeScroll = () => {
      destroyScrollTrigger();

      if (!desktopQuery.matches) {
        stopNativeScroll();
        resetMobileState();
        return true;
      }

      if (nativeScrollActive) return true;

      if (!nativeScrollActive) {
        window.addEventListener('scroll', onNativeScroll, { passive: true });
        window.addEventListener('resize', onNativeScroll);
        nativeScrollActive = true;
      }

      section.setAttribute('data-moducube-old-way-native', 'true');
      startNativeTicker();
      pairs.forEach((pair) => resetPanelPositions(pair, 0));
      updateNativeProgress(false);
      return true;
    };

    const initGsap = () => {
      if (!window.gsap || !window.ScrollTrigger) return false;

      window.gsap.registerPlugin(window.ScrollTrigger);
      destroyScrollTrigger();
      stopNativeScroll();

      if (!desktopQuery.matches) {
        resetMobileState();
        return true;
      }

      pairs.forEach((pair) => resetPanelPositions(pair, 0));
      setActiveState(0, 0, { animate: false });

      scrollTriggerInstance = window.ScrollTrigger.create({
        trigger: cards,
        start: () => `top+=${getStickyTop()} top`,
        end: () => `+=${Math.max(1, cards.offsetHeight - card.offsetHeight)}`,
        invalidateOnRefresh: true,
        onUpdate: (self) => updateFromProgress(self.progress, { animate: true }),
        onRefresh: (self) => updateFromProgress(self.progress, { animate: false }),
      });

      window.ScrollTrigger.refresh();
      return true;
    };

    const waitForGsap = () => {
      let attempts = 0;
      window.clearTimeout(fallbackTimer);

      const tryInit = () => {
        attempts += 1;

        if (initGsap()) return;

        startNativeScroll();

        if (attempts < 40) {
          fallbackTimer = window.setTimeout(tryInit, 100);
        }
      };

      tryInit();
    };

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', waitForGsap);
      reduceMotionQuery.addEventListener('change', waitForGsap);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(waitForGsap);
      reduceMotionQuery.addListener(waitForGsap);
    }

    waitForGsap();
  }

  function init() {
    document.querySelectorAll('[data-moducube-delivery-estimate]').forEach(initDeliveryEstimate);
    document.querySelectorAll('[data-moducube-assembly-video]').forEach(initAssemblyVideo);
    document.querySelectorAll('[data-moducube-comparison-scroll]').forEach(initComparisonTable);
    document.querySelectorAll('[data-moducube-old-way]').forEach(initOldWayPinnedScroll);
    document.querySelectorAll('[data-moducube-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-moducube-desktop-gallery]').forEach(initDesktopGallery);
    document.querySelectorAll('[data-moducube-fit-guide]').forEach(initFitGuide);
    document.querySelectorAll('[data-moducube-ugc]').forEach(initUgcStories);
    document.querySelectorAll('[data-moducube-faq]').forEach(initFaq);
    document.querySelectorAll('.moducube-product-hero').forEach(initExtendedStickyPurchase);
    document.querySelectorAll('.moducube-product-hero').forEach(initMobileStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
